import Vue from 'vue'
import VueResource from 'vue-resource'
import store from './../store'
import router from './../router'

Vue.use(VueResource);

/**
 * Ajax request static Params
 */
Vue.http.options.emulateJSON = true;
Vue.http.options.credentials = true;
Vue.http.options.loaderShow = true;
Vue.http.headers.common['X-CSRF-TOKEN'] = document.head.querySelector('meta[name="csrf-token"]').getAttribute('content');
Vue.http.interceptors.push(function(request, next) {

    // console.log(request);
    // console.log(request.body);

    request.method = 'POST';
    request.headers.set('Accept', 'application/json');

    var token = store.getters['account/accessToken'];
    if(token) { request.headers.set('Authorization', 'Bearer ' + token); }

    // add global params
    if(request.body instanceof FormData) {
        request.body.append('os', store.getters.global.os);
        request.body.append('lang', store.getters['language/selectedId']);
        request.body.append('screen_width', window.outerWidth);
        request.body.append('screen_height', window.outerHeight);
    } else {
        var body = !_.isEmpty(request.body) ? request.body : { };

        request.body = _.merge(body, {
            os : store.getters.global.os,
            lang : store.getters['language/selectedId'],
            screen_width : window.outerWidth,
            screen_height : window.outerHeight,
        });
    }

    if(request.loaderShow) { store.dispatch('loader/pending'); }

    next((response) => {
        if(request.loaderShow) { store.dispatch('loader/done'); }

        // console.log(request);
        // console.log(response);

        if(response.status === 200) {

            // check is_loggedin
            let is_loggedin = _.get(response, 'data.is_loggedin', false);

            if((store.getters.userIsLoggedIn && !is_loggedin) ||
                (!is_loggedin && _.get(response ,'data.message', '') == 'Login required')) {

                store.dispatch('account/logoutSilent').then(() => {
                    router.push({ name: 'login' });
                });
            }

        } else if(response.status == 401) {
            store.dispatch('account/logoutSilent').then(() => {
                router.push({ name: 'login' });
            });
        } else {
            window.alertify.alert('[' + response.status + '] ' + response.data.message);
        }

    });

});
